import React from "react";
import * as d3 from "d3";
import numeral from "numeral";
import PropTypes from "prop-types";
import { extendMoment } from "moment-range";
import moment from "moment";
import "./TrendingEventChart.css";

//TODO: need to switch away from these type of global vars
let c_xScale = () => { };
let c_yScale = () => { };
let c_getTrendDate = () => { };
let c_getTrendValue = () => { };

let c_getTrendValue2 = () => { };
let c_yScale2 = () => { };

let c_getEventDate = () => { };
let c_xAxis = () => { };
let c_yAxis = () => { };
let c_yAxis2 = () => { };

let c_zoomzoom;
let c_leftAxisWidth;
let c_rightAxisWidth;
let c_viewportWidth;
let c_viewportHeight;
let c_xAxisHeight;
let c_xAxisStart;
let c_maxTrenDatePosition;

class TrendingEventChart extends React.Component {
  constructor(props) {
    super(props);

    // this.state = {
    //   activePopover: {},
    //   containerClientRect: null
    // };

    this.zoom = this.zoom.bind(this);
    this.createVisualization = this.createVisualization.bind(this);
    this.transformLollipop = this.transformLollipop.bind(this);
    this.onEventMarkerClicked = this.onEventMarkerClicked.bind(this);
    this.addScope = this.addScope.bind(this);
    //this.createToolTipHtml = this.createToolTipHtml.bind(this);
  }

  // createToolTipHtml = data => {
  //   const { getEventDate } = this.props;
  //   /*
  //   - details
  //     - action that occured
  //     what changed?
  //       was personalization added?
  //       pesonalization was removed?
  //     # of personalization rulesets
  //     are there goals on the page?
  //   */

  //   let updated = moment(getEventDate(data));
  //   let html = `<p><b>Version: ${data.version}, ${data.language}</b></p>`;
  //   html += `<p style='color:silver'>updated ${updated.fromNow()} by ${data.lastUpdatedBy}</p>`;
  //   html += '<hr>';
  //   html += 'Changes';
  //   html += '';

  //   // data.personalizationDetails.renderingRulesets
  //   // data.trackingDetails
  //   return html;
  // }

  addScope(selector) {
    return `#${this.props.id} > ${selector}`;
  }

  render() {
    return (
      <div id={this.props.id} style={{ position: "relative" }}>
        <svg
          id='trend-svg'
          width={this.props.width}
          height={this.props.height}
        />
      </div>
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.pageMetrics && nextProps.pageMetrics === null) {
      d3.select(`#${this.props.id}`)
        .selectAll(".trendMarker")
        .attr("opacity", 1);
    }
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   return nextProps.width !== this.props.width ||
  //     nextProps.height !== this.props.height ||
  //     nextProps.id !== this.props.id ||
  //     nextProps.data.length !== this.props.data.length;
  // }

  componentDidUpdate() {
    //this.createVisualization();
  }

  componentDidMount() {
    // const containerNode = ReactDOM.findDOMNode(this.refs['history-container']);

    // debugger;
    // if(!containerNode){
    //   throw 'no container node found';
    // }

    // this.setState({containerClientRect: containerNode.getBoundingClientRect()});

    this.createVisualization();
  }

  onEventMarkerClicked(data, params) {
    const { onEventMarkerSelected } = this.props;
    if (onEventMarkerSelected) {
      onEventMarkerSelected(data);
    }

    //TODO: add styling
  }

  createVisualization() {
    const {
      width,
      height,
      trendData,
      getTrendDate,
      getTrendValue,
      getTrendValue2,
      eventData
    } = this.props;

    // Chart dimensions.
    c_getTrendDate = getTrendDate;
    c_getTrendValue = getTrendValue;
    c_getTrendValue2 = getTrendValue2;

    let margin = { top: 5, right: 5, bottom: 30, left: 50 };

    c_leftAxisWidth = 75;
    c_rightAxisWidth = 75;
    c_xAxisHeight = 30;

    c_viewportWidth =
      width - c_leftAxisWidth - c_rightAxisWidth - margin.left - margin.right;
    c_viewportHeight = height - margin.top - margin.bottom - c_xAxisHeight;
    c_xAxisStart = 385;
    let c_viewportStart = c_leftAxisWidth;

    let maxTrendDate = d3.max(trendData, d => getTrendDate(d));
    let minTrendDate = d3.min(trendData, d => getTrendDate(d));

    let yMaxValue = d3.max(trendData, d => getTrendValue(d));
    let yAvgValue = d3.mean(trendData, d => getTrendValue(d));
    let yMinValue = d3.min(trendData, d => getTrendValue(d));

    let yMaxValue2 = d3.max(trendData, d => getTrendValue2(d));
    let yMinValue2 = d3.min(trendData, d => getTrendValue2(d));

    // console.log(`x-range: ${xMin} - ${xMax}`);
    console.log(`y-range: ${yMinValue} - ${yMaxValue}`);
    console.log(`y2-range: ${yMinValue2} - ${yMaxValue2}`);

    c_xScale = d3.time
      .scale()
      .domain([minTrendDate, maxTrendDate])
      .range([0, c_viewportWidth]);

    c_maxTrenDatePosition = c_xScale(maxTrendDate);

    c_yScale = d3.scale
      .linear()
      //.domain([yMinValue, yMaxValue])
      .domain([0, yMaxValue])
      .range([c_viewportHeight, 0]);

    c_yScale2 = d3.scale
      .linear()
      .domain([0, yMaxValue2])
      //.domain([0, 60000])
      .range([c_viewportHeight, 0]);

    c_xAxis = d3.svg
      .axis()
      .scale(c_xScale)
      .orient("bottom")
      .tickSize(-c_viewportHeight)
      //.ticks(d3.time.days, 1);
      .ticks(15);

    c_yAxis = d3.svg
      .axis()
      .scale(c_yScale)
      .orient("left")
      .tickSize(-c_viewportWidth)
      //ticks
      .tickFormat(d3.format(",.2f"));

    c_yAxis2 = d3.svg
      .axis()
      .scale(c_yScale2)
      .orient("right")
      //ticks
      .tickFormat(d3.format(",0f"));

    //TODO: set scaleExtent based on data
    c_zoomzoom = d3.behavior
      .zoom()
      .scaleExtent([1, 1])
      .x(c_xScale)
      .on("zoom", this.zoom);

    // Create the SVG container and set the origin.
    let rootSvg = d3
      .select(this.addScope('#trend-svg'))
      .selectAll("g")
      .remove();

    let svg = d3
      .select(this.addScope('#trend-svg'))
      .append("g")
      .classed("viewport", true)
      .attr("width", c_viewportWidth)
      .attr("height", c_viewportHeight)
      .attr("transform", "translate(" + c_leftAxisWidth + ",0)")
      // .attr("width", c_viewportWidth)
      // .attr("height", c_viewportHeight)
      .call(c_zoomzoom);

    var rect = svg.append("rect")
      .attr("width", c_viewportWidth)
      .attr("height", c_viewportHeight)
      .style("fill", "none")
      .style("pointer-events", "all");

    svg.append("defs").append("clipPath")
      .attr("id", "clip")
      .append("rect")
      .attr("width", c_viewportWidth)
      .attr("height", c_viewportHeight);

    let viewport = svg.append("g")
      .attr("clip-path", "url(#clip)");

    this.appendAxes(svg, margin);

    this.drawTrendLines(viewport, minTrendDate, maxTrendDate, trendData);
    if (eventData !== undefined) {
      this.drawEventMarkers(viewport, eventData)
    }

    //debugger;
    let minus10 = new Date();
    minus10.setDate(maxTrendDate.getDate() - 2);
    let initialZoom = c_zoomzoom
      .x(c_xScale.domain([minTrendDate, minus10]))
      //.y(c_yScale.domain([yMin, yMax]))
      .event;

    //svg.call(initialZoom);

  }

  zoom() {

    let viewport = d3
      .select(`#${this.props.id}`)
      .select("svg")
      .select(".viewport");

    let e = d3.event;
    let w = viewport.attr("width");
    let h = viewport.attr("height");
    let path = viewport.select(".trendLine");
    let path2 = viewport.select(".trendLine2");
    
    this.drawLinePath(path, path2);

    //rescale the axes
    //svg.select(".y.axis").call(c_yAxis);
    viewport.select(".x.axis").call(c_xAxis);
    viewport
      .selectAll(".eventMarker")
      .attr("transform", this.transformLollipop);

    //TODO: will need this
    // svg
    //   .selectAll(".y_avg_ref")
    //   .attr("x1", d => d.x1)
    //   .attr("y1", d => c_yScale(d.y1))
    //   .attr("x2", d => d.x2)
    //   .attr("y2", d => c_yScale(d.y2));
  }

  fillEmptyTrendDays(min, max, data) {
    //debugger;
    const momentRange = extendMoment(moment);
    const createResult = (date, value, value2) => {
      return { date: date, value: value, value2: value2 };
    };
    let range = momentRange.range(min, max);
    let allDatesInRange = Array.from(range.by("days"));
    //debugger;

    //console.log(allDatesInRange.forEach((e) => console.log(e.format(dateFormat))));
    let results = [];

    allDatesInRange.forEach(e => {
      //dont ask
      let d = new Date(e.toDate().toDateString());
      let record = data.find(r => c_getTrendDate(r).getTime() === d.getTime());

      // if (record !== undefined) {
      //   console.log('yea, found the record')
      // }

      let entry =
        record === undefined
          ? createResult(d, 0, 0)
          : createResult(d, c_getTrendValue(record), c_getTrendValue2(record));

      results.push(entry);
    });

    return results;
  }

  drawTrendLines(container, xMin, xMax, dataset) {
    let trendDataset = this.fillEmptyTrendDays(xMin, xMax, dataset);

    let path = container
      .datum(trendDataset)
      .append("path")
      .classed("trendLine", true)
      .attr("fill", "none")
      .attr("stroke", "steelblue")
      .attr("stroke-linejoin", "round")
      .attr("stroke-linecap", "round")
      .attr("stroke-width", 1.5);

    let path2 = container
      .datum(trendDataset)
      .append("path")
      .classed("trendLine2", true)
      .attr("fill", "none")
      .attr("stroke", "green")
      .attr("stroke-linejoin", "round")
      .attr("stroke-linecap", "round")
      .attr("stroke-width", 1.5);

    this.drawLinePath(path, path2);
  }

  drawLinePath(path, path2) {
    let line = d3.svg
      .line()
      //.defined((d) => d !== null)
      .x(d => c_xScale(d.date))
      .y(d => c_yScale(d.value));

    path.attr("d", line);

    let line2 = d3.svg
      .line()
      .x(d => c_xScale(d.date))
      .y(d => c_yScale2(d.value2));

    path2.attr("d", line2);
  }

  onDotHover(data) {
    this.props.onDotHover(data);
  }

  drawEventMarkers(container, eventData) {
    //todo: size based type and impact of event
    let radius = 18;
    let g = container
      .selectAll(".eventMarker")
      .data(eventData)
      .enter()
      .append("g")
      .classed("eventMarker", true)
      .attr("transform", this.transformLollipop);

    let self = this;

    //const tooltipContainer = d3.select("div.tooltip");
    let circle = g
      .append("circle")
      .attr("r", radius)
      .on("click", function (d, i) {
        self.onEventMarkerClicked(d);
      })
      .attr("id", d => `v_${d.language}${d.version}`)
      .on("mouseover", function (d, i) {
        self.onDotHover({
          data: d,
          clientRect: this.getBoundingClientRect()
        });
      })
      .on("mouseout", (d, i) => this.onDotHover(null));

    let line = g
      .append("line")
      .attr("stroke-width", 2)
      .attr("stroke", "silver")
      .attr("x1", 0)
      .attr("y1", radius)
      .attr("x2", 0)
      .attr("y2", c_viewportHeight * 0.75);

    //TODO: standardize on how the lollipop is rendered (i.e central * .25)
  }

  transformLollipop(d) {
    const { getEventDate } = this.props;

    //let date = c_getEventDate(d)
    let date = getEventDate(d);
    let x = c_xScale(date);
    let y = c_viewportHeight * 0.25;
    let t = "translate(" + x + "," + y + ")";

    return t;
  }

  appendAxes(container, margin) {
    const { xLabel, yLabel } = this.props;

    container
      .append("g")
      .classed("x axis", true)
      .attr("transform", "translate(0," + c_xAxisStart + ")")
      .call(c_xAxis)
      .append("text")
      .classed("axis_label", true)
      .attr("x", 35)
      .attr("y", margin.bottom)
      .style("text-anchor", "end")
      .style("font-size", "16px")
      .attr("font-weight", "bold")
      .text(xLabel);

    container
      .append("g")
      .classed("y axis", true)
      .call(c_yAxis)
      .append("text")
      .attr("transform", "rotate(-90)")
      .attr("x", -c_viewportHeight + margin.bottom + 60)
      .attr("y", -margin.left + 0)
      .attr("dy", ".71em")
      .style("text-anchor", "end")
      .style("font-size", "16px")
      .attr("font-weight", "bold")
      .text(yLabel);

    container
      .append("g")
      .classed("y2 axis", true)
      .attr("transform", "translate(" + c_viewportWidth + ",0)")
      .call(c_yAxis2)
      .append("text")
      .attr("transform", "rotate(-90)")
      .attr("x", -c_viewportHeight + margin.bottom + 30)
      .attr("y", -margin.left + 110)
      .attr("dy", ".71em")
      .style("text-anchor", "end")
      .style("font-size", "16px")
      .attr("font-weight", "bold")
      .text("Visits"); //todo; take as param

    // container
    //   .append("svg:line")
    //   .classed("axisLine hAxisLine", true)
    //   .attr("x1", 0)
    //   .attr("y1", 0)
    //   .attr("x2", c_viewportWidth)
    //   .attr("y2", 0)
    //   .attr("transform", "translate(0," + c_viewportHeight + ")");

    // container
    //   .append("svg:line")
    //   .classed("axisLine vAxisLine", true)
    //   .attr("x1", 0)
    //   .attr("y1", 0)
    //   .attr("x2", 0)
    //   .attr("y2", c_viewportHeight);
  }
}

TrendingEventChart.propTypes = {
  id: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  trendData: PropTypes.array.isRequired,
  getTrendDate: PropTypes.func.isRequired,
  getTrendValue: PropTypes.func.isRequired,
  getTrendValue2: PropTypes.func.isRequired,
  eventData: PropTypes.array,
  getEventDate: PropTypes.func.isRequired,
  xLabel: PropTypes.string.isRequired,
  yLabel: PropTypes.string.isRequired,
  onEventMarkerSelected: PropTypes.func
};

export default TrendingEventChart;



// WEBPACK FOOTER //
// ./src/charts/TrendingEventChart.js